import { render, staticRenderFns } from "./EcologyOverview.vue?vue&type=template&id=83ac54ae&scoped=true&lang=html&"
import script from "./EcologyOverview.vue?vue&type=script&lang=js&"
export * from "./EcologyOverview.vue?vue&type=script&lang=js&"
import style0 from "./EcologyOverview.vue?vue&type=style&index=0&id=83ac54ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ac54ae",
  null
  
)

export default component.exports